export enum ContentStatus {
  NEW = 'New',
  SPIKED = 'Spiked',
  READ_ONLY = 'Read_Only',
  WRITING = 'Writing',
  PUBLISHED = 'Published',
  WAITING_FOR_EDITING = 'WaitingForEditing',
  EDITING = 'Editing',
  WAITING_FOR_JOURNALIST_EDITING = 'WaitingForJournalistEditing',
  JOURNALIST_EDITING = 'JournalistEditing',
  WAITING_FOR_SUBEDITING = 'WaitingForSubEditing',
  SUBEDITING = 'SubEditing',
  SUBEDITOR_APPROVED = 'SubEditorApproved',
}

export function getStatusDescription(status: ContentStatus): string {
  const statusDescriptions: Record<ContentStatus, string> = {
    [ContentStatus.NEW]: 'New',
    [ContentStatus.SPIKED]: 'Spiked',
    [ContentStatus.READ_ONLY]: 'Read Only',
    [ContentStatus.WRITING]: 'Writing',
    [ContentStatus.PUBLISHED]: 'Published',
    [ContentStatus.WAITING_FOR_EDITING]: 'Waiting for Editing',
    [ContentStatus.EDITING]: 'Editing',
    [ContentStatus.WAITING_FOR_JOURNALIST_EDITING]:
      'Waiting for Journalist Editing',
    [ContentStatus.JOURNALIST_EDITING]: 'Journalist Editing',
    [ContentStatus.WAITING_FOR_SUBEDITING]: 'Waiting for Sub-editing',
    [ContentStatus.SUBEDITING]: 'Sub-editing',
    [ContentStatus.SUBEDITOR_APPROVED]: 'Sub-editor Approved',
  };

  return statusDescriptions[status] || 'Unknown Status';
}
